import { useMemo } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';

import { useFeatureAccessControl } from 'hooks/useFeatureAccessControl';

import { Spinner } from '@atoms/Spinner/Spinner';

type ConfigurationKey = keyof ReturnType<typeof useFeatureAccessControl>;

type Props = {
  requiredConfiguration: ConfigurationKey;
};

export const RequireConfiguration = ({ requiredConfiguration }: Props) => {
  const { organisationId } = useParams();

  const configuration = useFeatureAccessControl();

  const isConfigurationEnabled = useMemo(
    () => configuration[requiredConfiguration],
    [configuration, requiredConfiguration]
  );

  if (configuration.isLoading) {
    return <Spinner size="large" />;
  }

  return (
    <>
      {isConfigurationEnabled ? (
        <Outlet />
      ) : (
        <Navigate to={`/org/${organisationId}`} replace />
      )}
    </>
  );
};
